import React from 'react'
import { RepairAndInquiriesStatusEntity } from '../../../../customEntites/RepairAndInquiries.entity'
import { ServiceRequestItem } from '../../../../api/repairAndInquiries'
import { RequestSummary } from './RequestSummary'

export const RequestsList = ({
  requests,
  statuses,
}: {
  requests: ServiceRequestItem[],
  statuses: RepairAndInquiriesStatusEntity[],
}) => {
  return (
    <div className='w-full'>
      {requests?.map((request) => (
        <RequestSummary
          statuses={statuses}
          key={request?.code}
          request={request}
        />
      ))}
    </div>
  )
}
